import PropTypes from 'prop-types';
import React from 'react';
import styles from './HoverOutLayer.module.css';
export default function HoverOutLayer(_a) {
    var children = _a.children, hoverStack = _a.hoverStack, onMouseMove = _a.onMouseMove;
    return (React.createElement("div", { className: styles.screenArea, onMouseMove: hoverStack.length ? onMouseMove : null }, children));
}
HoverOutLayer.propTypes = {
    onMouseMove: PropTypes.func,
    children: PropTypes.node.isRequired,
    hoverStack: PropTypes.array.isRequired,
};
